import { EMAIL_REGEX, NAME_REGEX, PHONE_REGEX } from "../constants";

export const commonValidation = {

    validateName : (name) => {
        if (name.trim() === "") {
            return "Name is required" 
          } else if (!NAME_REGEX.test(name)) {
            return "Invalid name" 
          } else {
            return "" 
          }
    },

    validatePhone : (phone) => {
        if (phone.trim() === "") {
            return "Phone number is required" 
          } else if (!PHONE_REGEX.test(phone)) {
            return "Invalid phone number" 
          } else {
            return "" 
          }
    },
    validateEmail : (email) => {
        if (email.trim() === "") {
            return "Email is required" 
          } else if (!EMAIL_REGEX.test(email)) {
            return "Invalid email" 
          } else {
            return "" 
          }
    },
    validateQuery : (query) => {
        if (query.trim() === "") {
            return "Query is required";
          } else {
            return "" 
          }

    }
}